{
  "newChat": "Nieuwe chat",
  "sessions": {
    "search": "Chats zoeken…",
    "empty": "Nog geen gesprekken. Begin er een met “Nieuwe chat”.",
    "noMatches": "Geen chats gevonden voor “{{query}}”.",
    "untitled": "Naamloze chat",
    "replying": "Assistent antwoordt",
    "unread": "Nieuw antwoord",
    "actions": "Gespreksacties",
    "rename": "Naam wijzigen",
    "renameLabel": "Titel van het gesprek",
    "clickToRename": "Klik om de naam te wijzigen",
    "pin": "Vastzetten",
    "unpin": "Losmaken",
    "delete": "Chat verwijderen",
    "deleteTitle": "Dit gesprek verwijderen?",
    "deleteDescription": "“{{title}}” en de berichten worden verwijderd. De runlogs blijven beschikbaar voor beheerders.",
    "deleted": "Gesprek verwijderd",
    "groups": {
      "pinned": "Vastgezet",
      "today": "Vandaag",
      "yesterday": "Gisteren",
      "week": "Afgelopen 7 dagen",
      "month": "Afgelopen 30 dagen",
      "older": "Ouder"
    }
  },
  "conversation": {
    "title": "Gesprek",
    "label": "Gesprek",
    "scrollToEnd": "Naar het laatste bericht",
    "emptySession": "Stuur een bericht om het gesprek te beginnen."
  },
  "newChatPage": {
    "greeting": {
      "morning": "Goedemorgen, {{name}}",
      "afternoon": "Goedemiddag, {{name}}",
      "evening": "Goedenavond, {{name}}",
      "night": "Nog laat aan het werk, {{name}}?"
    },
    "subtitle": "Vraag wat je wilt — voeg bestanden, afbeeldingen of documenten toe als context.",
    "placeholder": "Bericht aan {{agent}}…",
    "agents": "Of kies een andere assistent",
    "noAgents": "Geen assistenten beschikbaar",
    "noAgentsHint": "Er zijn nog geen agents waarmee je kunt chatten. Vraag een beheerder er een voor chat in te schakelen.",
    "createAgent": "Agent maken"
  },
  "agentPicker": {
    "label": "Assistent",
    "placeholder": "Kies een assistent"
  },
  "composer": {
    "label": "Bericht",
    "placeholder": "Stuur een bericht…",
    "send": "Versturen",
    "stop": "Stoppen met genereren",
    "attach": "Bestanden toevoegen",
    "attachHint": "Bestanden toevoegen (of plakken / slepen)",
    "hint": "Enter om te versturen · Shift+Enter voor een nieuwe regel · / om te focussen",
    "uploading": "Uploaden… {{percent}}%",
    "uploadFailed": "Uploaden mislukt",
    "removeAttachment": "{{name}} verwijderen",
    "waitForUploads": "Wachten op uploads…",
    "tooManyFiles": "Je kunt maximaal {{count}} bestanden per bericht toevoegen.",
    "unsupportedFile": "Niet ondersteund: {{names}}",
    "dropHere": "Laat los om toe te voegen",
    "dropHint": "Afbeeldingen, pdf's, Office-documenten, tekst en code"
  },
  "reasoning": {
    "label": "Redenering",
    "thinking": "Denkt na…",
    "thoughtFor_one": "{{count}} seconde nagedacht",
    "thoughtFor_other": "{{count}} seconden nagedacht"
  },
  "phase": {
    "waiting": "Denkt na…",
    "tool": "Gebruikt {{name}}…",
    "skill": "Laadt skill {{name}}…",
    "mcp": "Verbindt met {{name}}…"
  },
  "activity": {
    "kind": {
      "tool": "Toolaanroep",
      "skill": "Vaardigheid",
      "mcp": "Integratie"
    },
    "verb": {
      "tool": "Gebruikt",
      "skill": "Geladen",
      "mcp": "Verbonden"
    },
    "running": "Bezig",
    "completed": "Voltooid",
    "failed": "Mislukt",
    "input": "Invoer",
    "response": "Antwoord",
    "error": "Fout",
    "noInput": "Geen invoer voor deze aanroep.",
    "noResponse": "Geen antwoord vastgelegd voor deze aanroep.",
    "waiting": "Wachten op het antwoord…"
  },
  "message": {
    "copy": "Kopiëren",
    "retry": "Opnieuw proberen",
    "failed": "De assistent kon dit antwoord niet afmaken.",
    "stopped": "Gestopt.",
    "paused": "Gepauzeerd — wacht op menselijke invoer.",
    "tokensTotal": "Invoer- en uitvoertokens voor dit antwoord",
    "usageDetail": "{{input}} in · {{output}} uit · {{cached}} uit cache",
    "tokens": "{{formatted}} tokens gebruikt"
  },
  "export": {
    "copy": "Kopiëren als Markdown",
    "download": "Markdown downloaden",
    "copied": "Gesprek gekopieerd als Markdown",
    "user": "Jij",
    "attachments": "Bijlagen"
  },
  "info": {
    "title": "Gespreksdetails",
    "turns": "Beurten",
    "created": "Gestart",
    "updated": "Laatste activiteit",
    "contextId": "Context-ID",
    "compression": "Contextcompressie",
    "compressionHint": "Vat oudere beurten samen in een doorlopende samenvatting, zodat lange gesprekken binnen de context van het model blijven.",
    "compressNow": "Nu comprimeren",
    "compressed": "Samenvatting bijgewerkt",
    "summary": "Doorlopende samenvatting",
    "noSummary": "Nog geen samenvatting. Die wordt na een paar beurten geschreven als compressie aan staat.",
    "facts": "Sessiefeiten",
    "noFacts": "Nog geen feiten vastgelegd."
  },
  "history": {
    "title": "Chatgeschiedenis",
    "description": "Al je gesprekken. Zoek op titel, assistent of model.",
    "allAgents": "Alle assistenten",
    "summarized": "Samengevat",
    "compressionOn": "Compressie aan",
    "compressionOff": "Uit",
    "emptyTitle": "Nog geen gesprekken",
    "emptyDescription": "Je chats met assistenten verschijnen hier.",
    "columns": {
      "title": "Titel",
      "agent": "Assistent",
      "turns": "Beurten",
      "memory": "Geheugen",
      "updated": "Laatste activiteit",
      "created": "Gestart"
    }
  },
  "playground": {
    "title": "Testomgeving",
    "description": "Probeer prompts en instellingen uit zonder de agent te wijzigen.",
    "compare": "Vergelijken",
    "compareHint": "Hetzelfde bericht naast elkaar tegen twee configuraties uitvoeren",
    "pane": "Configuratie {{pane}}",
    "settings": "Instellingen",
    "settingsFor": "Instellingen — {{pane}}",
    "settingsHint": "Afwijkingen gelden alleen voor berichten uit de playground. Ongewijzigde instellingen volgen de configuratie van de agent.",
    "changed": "Afwijkend van de configuratie van de agent",
    "reset": "Herstellen",
    "resetAll": "Alles herstellen",
    "save": "Opslaan in agent",
    "saveTitle": "{{agent}} bijwerken?",
    "saveDescription_one": "De gewijzigde instelling wordt onderdeel van de configuratie van de agent (er wordt een nieuwe revisie vastgelegd).",
    "saveDescription_other": "De {{count}} gewijzigde instellingen worden onderdeel van de configuratie van de agent (er wordt een nieuwe revisie vastgelegd).",
    "revisionNote": "Opgeslagen vanuit de playground",
    "clear": "Nieuw gesprek",
    "removePane": "Deze configuratie verwijderen",
    "placeholder": "Stuur een testbericht…",
    "placeholderCompare": "Stuur hetzelfde bericht naar beide configuraties…",
    "empty": "Stuur een bericht om deze configuratie te proberen.",
    "sessionTitle": "Testomgeving · {{agent}} ({{pane}})",
    "providerDefault": "Standaard",
    "noMcp": "Geen MCP-servers geconfigureerd.",
    "noSkills": "Geen skills beschikbaar.",
    "fields": {
      "model": "Taalmodel",
      "systemPrompt": "Systeemprompt",
      "temperature": "Temperatuur",
      "topP": "Top P",
      "topK": "Top K",
      "thinking": "Modeldenken",
      "cacheStatic": "Cache: instructies",
      "cacheMessages": "Cache: gesprek",
      "mcp": "MCP-servers",
      "skills": "Vaardigheden"
    },
    "hints": {
      "temperature": "Lager is gerichter en voorspelbaarder, hoger is creatiever.",
      "thinking": "Laat modellen die het ondersteunen eerst redeneren voordat ze antwoorden.",
      "cache": "Promptcaching (Anthropic-modellen): hoe lang gecachte instructies en het gesprek warm blijven."
    },
    "cache": {
      "5m": "5 minuten",
      "1h": "1 uur",
      "off": "Uit"
    }
  },
  "automations": {
    "title": "Automatiseringen",
    "new": "Nieuwe automatisering",
    "newTitle": "Nieuwe automatisering",
    "search": "Automatiseringen zoeken…",
    "noMatches": "Geen automatiseringen gevonden.",
    "emptyList": "Nog geen automatiseringen.",
    "emptyTitle": "Automatiseer een terugkerende taak",
    "selectTitle": "Kies een automatisering",
    "emptyDescription": "Een automatisering is een herbruikbare prompt met parameters. Voer hem hier uit, vanuit een planning of via de webhook.",
    "notFound": "Deze automatisering bestaat niet meer.",
    "back": "Terug naar automatiseringen",
    "api": "API",
    "paramCount_one": "{{count}} invoerveld",
    "paramCount_other": "{{count}} invoervelden",
    "runCount_one": "{{count}} keer uitgevoerd",
    "runCount_other": "{{count}} keer uitgevoerd",
    "lastRun": "Laatst uitgevoerd",
    "create": "Automatisering maken",
    "created": "Automatisering “{{name}}” gemaakt",
    "saved": "Automatisering “{{name}}” opgeslagen",
    "deleted": "Automatisering “{{name}}” verwijderd",
    "delete": "Verwijderen",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription": "Planningen en koppelingen die deze automatisering aanroepen, werken dan niet meer.",
    "run": "Uitvoeren",
    "runAgain": "Opnieuw uitvoeren",
    "saveBeforeRun": "Sla je wijzigingen op voordat je uitvoert",
    "runTitle": "“{{name}}” uitvoeren",
    "runDescription": "Vul de parameters in. {{agent}} voert de automatisering uit en de uitvoer verschijnt hieronder.",
    "running": "Bezig… bij langere taken kan dit even duren.",
    "noParams": "Deze automatisering heeft geen parameters.",
    "output": "Uitvoer",
    "noOutput": "De run is klaar maar leverde geen uitvoer op.",
    "close": "Sluiten",
    "done": "Klaar",
    "insert": "Invoegen",
    "fields": {
      "name": "Naam",
      "description": "Omschrijving",
      "agent": "Uitvoerende agent",
      "agentPlaceholder": "Kies een agent"
    },
    "params": {
      "title": "Invoervelden",
      "description": "Invoer voor elke run. Gebruik ze in de sjablonen als {{example}}; bestandsparameters worden aan het bericht toegevoegd.",
      "add": "Parameter toevoegen",
      "empty": "Nog geen parameters — voeg er een toe om deze automatisering herbruikbaar te maken.",
      "label": "Weergavenaam",
      "labelPlaceholder": "Naam klant",
      "name": "Naam",
      "type": "Soort",
      "required": "Verplicht",
      "default": "Standaardwaarde",
      "noDefault": "Geen standaardwaarde",
      "remove": "Parameter verwijderen",
      "fileHint": "Wordt bij elke run geüpload en aan het bericht toegevoegd.",
      "invalidName": "Gebruik letters, cijfers en underscores, en begin niet met een cijfer.",
      "duplicate": "Een andere parameter gebruikt deze naam al.",
      "types": {
        "string": "Tekst",
        "number": "Getal",
        "file": "Bestand"
      }
    },
    "templates": {
      "title": "Opdracht",
      "description": "Wat de agent bij elke run ontvangt.",
      "message": "Berichtsjabloon",
      "messageHint": "Wordt verstuurd als het gebruikersbericht.",
      "messagePlaceholder": "Schrijf een korte samenvatting van {{topic}} voor {{audience}}.",
      "instructions": "Extra instructies",
      "instructionsHint": "Alleen voor deze automatisering toegevoegd aan de systeemprompt van de agent.",
      "instructionsPlaceholder": "Antwoord in een formele toon."
    },
    "issues": {
      "unknown": "{{placeholder}} is geen parameter.",
      "file": "Bestandsparameter “{{name}}” kan niet in tekst worden gebruikt.",
      "unterminated": "Accolades niet in balans: sluit elke {{open}} af met {{close}}.",
      "fix": "Los de problemen in het sjabloon hieronder op."
    },
    "apiAccess": {
      "title": "API-toegang",
      "description": "Laat andere systemen deze automatisering starten met een HTTP-verzoek.",
      "enable": "Webhook inschakelen",
      "enableHint": "Bij het opslaan wordt een geheim aangemaakt; dat wordt één keer getoond.",
      "url": "Webhook-URL",
      "example": "Voorbeeldverzoek",
      "secretSet": "Er is een geheim ingesteld. Vervang het als het mogelijk is uitgelekt.",
      "noSecret": "Nog geen geheim.",
      "disableWarning": "Bij opslaan wordt de webhook uitgeschakeld en het geheim ingetrokken."
    },
    "rotate": "Geheim vervangen",
    "rotateTitle": "Webhookgeheim vervangen?",
    "rotateDescription": "Het huidige geheim werkt direct niet meer. Werk elke aanroeper bij met het nieuwe geheim.",
    "secretTitle": "Webhookgeheim",
    "secretDescription": "Stuur het bij elk verzoek mee als “Authorization: Bearer <geheim>”."
  },
  "endpoints": {
    "title": "Chat-endpoints",
    "description": "Geef websites en apps een met een token beveiligde chat-API voor één agent — JSON of streaming.",
    "new": "Nieuw endpoint",
    "newDescription": "Eén endpoint per agent. Er wordt een bearer-token aangemaakt dat één keer wordt getoond.",
    "editDescription": "Wijzig hoe dit endpoint zich gedraagt. Het token blijft hetzelfde tenzij je het vervangt.",
    "create": "Endpoint maken",
    "created": "Endpoint “{{name}}” gemaakt",
    "saved": "Endpoint “{{name}}” opgeslagen",
    "deleted": "Endpoint “{{name}}” verwijderd",
    "edit": "Bewerken",
    "delete": "Verwijderen",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription": "Clients die dit endpoint gebruiken krijgen direct foutmeldingen.",
    "rotate": "Token vervangen",
    "rotateTitle": "Token van “{{name}}” vervangen?",
    "rotateDescription": "Het huidige token werkt direct niet meer. Werk elke client bij met het nieuwe token.",
    "toggle": "{{name}} inschakelen",
    "perMinute_one": "{{count}}/minuut",
    "perMinute_other": "{{count}}/minuut",
    "emptyTitle": "Nog geen chat-endpoints",
    "emptyDescription": "Maak een endpoint om een agent in je eigen website, app of workflowtool te gebruiken.",
    "tokenTitle": "Token voor “{{name}}”",
    "tokenDescription": "Gebruik het als bearer-token. Het wordt niet opnieuw getoond — vervang het als je het kwijtraakt.",
    "done": "Klaar",
    "stats": {
      "active": "Ingeschakelde endpoints",
      "requests": "Verzoeken",
      "lastUsed": "Laatste verzoek"
    },
    "columns": {
      "enabled": "Aan",
      "name": "Naam",
      "token": "Tokenprefix",
      "behaviour": "Gedrag",
      "rateLimit": "Limiet",
      "uses": "Verzoeken",
      "lastUsed": "Laatst gebruikt"
    },
    "badges": {
      "continuity": "Geheugen",
      "reasoning": "Redenering",
      "tools": "Toolaanroepen"
    },
    "fields": {
      "agent": "Gekoppelde agent",
      "agentHint": "Agents die al een endpoint hebben staan niet in de lijst.",
      "agentPlaceholder": "Kies een agent",
      "name": "Naam",
      "enabled": "Ingeschakeld",
      "enabledHint": "Uitgeschakelde endpoints weigeren elk verzoek.",
      "continuity": "Gespreksgeheugen",
      "continuityHint": "Clients mogen een context_id meesturen om een eerder gesprek voort te zetten.",
      "reasoning": "Redenering tonen",
      "reasoningHint": "Stream de redenering van het model en tussentijdse tekst. Uit: clients zien alleen statusstappen en het eindantwoord.",
      "tools": "Toolaanroepen tonen",
      "toolsHint": "Stream toolaanroepen en hun resultaten naar de client.",
      "rateLimit": "Limiet",
      "rateLimitHint": "Maximaal aantal verzoeken per minuut voor dit endpoint.",
      "perMinuteUnit": "per min"
    },
    "api": {
      "url": "Endpoint-URL",
      "json": "JSON-antwoord",
      "sse": "Streamen (SSE)",
      "jsonHint": "Geeft { output, post, suppress_reason, run_uid, context_id } terug zodra het antwoord compleet is. post is false als de agent zweeg: toon dan niets.",
      "sseHintFull": "Streamt run_started, thinking_delta, text_delta, tool-events en een afsluitend done-event { output, post, suppress_reason }. Bij text_reset: gooi de getoonde tekst weg.",
      "sseHintStatus": "Streamt status_step-updates terwijl de agent werkt, daarna text_delta en een afsluitend done-event { output, post, suppress_reason }. Bij text_reset: gooi de getoonde tekst weg."
    }
  }
}
